<template>
    <v-card class="ma-0 pa-0">
        <p-packages-edit-audience-popup ref="p-packages-edit-audience-popup"></p-packages-edit-audience-popup>
        <p-packages-edit-version-popup ref="p-packages-edit-version-popup"></p-packages-edit-version-popup>
        <v-card-actions>
            <v-card elevation="0" width="100%" class="ma-0 pa-0" outlined>
                <v-data-table
                        style="width: 100%;"
                        fixed-header
                        :items="deployedPackages"
                        :headers="headers"
                        hide-default-footer
                        disable-pagination>
                    <template v-slot:item.updated="{ item }">
                        <v-card-text>{{ item.updated | formatDate }}</v-card-text>
                    </template>
                    <template v-slot:item.aud="{ item }">
                        <v-btn :disabled="!ifCanSetAudiencesForDeployedPackage()"
                               outlined
                               color="orange"
                               class="mr-1"
                               @click="onPressEditAudience(item)">
                            {{item.aud}}
                        </v-btn>
                    </template>
                    <template v-slot:item.version="{ item }">
                        <v-btn :disabled="!ifCanSetVersionForDeployedPackage()"
                               outlined
                               color="green"
                               class="mr-1"
                               @click="onPressEditVersion(item)">
                            {{ item.minver || '-'}} - {{ item.maxver || '-'}}
                        </v-btn>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="!ifCanDeleteDeployedPackage()"
                                        :loading="deleting.includes(item.name)"
                                       icon
                                       color="red"
                                       v-bind="attrs"
                                       v-on="on"
                                       class="mr-1"
                                       @click="onPressDelete(item)">
                                    <v-icon size="22">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Delete Package</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="!ifCanDeployPackage()"
                                       icon
                                       color="blue"
                                       v-bind="attrs"
                                       v-on="on"
                                       class="mr-1"
                                       @click="onPressAddToDeploy(item)">
                                    <v-icon size="22">mdi-folder-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Deploy package</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </v-card-actions>
    </v-card>
</template>

<script>

import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import PPackagesEditAudiencePopup
    from "@/modules/mpackages/views/popups/p-packages-edit-audience-popup/p-packages-edit-audience-popup";
import PPackagesEditVersionPopup
    from "@/modules/mpackages/views/popups/p-packages-edit-version-popup/p-packages-edit-version-popup";
import {SlackLogManager} from "@/common/SlackLogManager";

export default {
    name: "v-packages-active-list",
    components: {PPackagesEditVersionPopup, PPackagesEditAudiencePopup},
    data: () => ({
        headers: [
            {text: 'Name', sortable: true, value: 'name', class: "white blue--text"},
            {text: 'Owner', sortable: true, value: 'owner', class: "white blue--text"},
            {text: 'Audiences', sortable: true, value: 'aud', class: "white blue--text"},
            {text: 'Version', sortable: true, value: 'version', class: "white blue--text"},
            {text: 'Updated', sortable: true, value: 'updated', class: "white blue--text"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:"120px"}
        ],
        deleting: [],
    }),
    mounted() {
        this.reloadData()
    },
    methods:{
        reloadData(){
            PackageStoreUtils.fethDeployedPackageList()
            .then(() => {
                this.$notify({title: "Succes", text: "", type: "succes"});
            }).catch((error) => {
                this.$notify({title: 'Error:', text: error, type: "error"});
            })
        },
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanDeleteDeployedPackage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_AC_DELETE_PACKAGE.id)
        },
        ifCanSetVersionForDeployedPackage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_AC_SET_VERSION_PACKAGE.id)
        },
        ifCanSetAudiencesForDeployedPackage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_AC_SET_AUDIENCE_PACKAGE.id)
        },
        ifCanDeployPackage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.DEPLOY_TAB.subpermissions.DEPLOY_TAB_ADD_PACKAGE_TO_DEPLOY.id)
        },
        onPressEditVersion(deployedPackage){
            this.$refs['p-packages-edit-version-popup'].show(deployedPackage)
        },
        onPressEditAudience(deployedPackage){
            this.$refs['p-packages-edit-audience-popup'].show(deployedPackage)
        },
        onPressAddToDeploy(deployedPackage){
            this.$store.commit('deploy-store/addPendingForDeploy', deployedPackage.name)
            this.$notify({title: 'Added: ' + deployedPackage.name, text: "", type: "succes"});
        },

        onPressDelete(deployedPackage){
            this.$confirm("Are you sure?" + deployedPackage.name)
            .then(() => {
                this.deleting.push(deployedPackage.name)
                PackageStoreUtils.removeDeployedPackage(deployedPackage.name)
                    .then(() => {
                        this.deleting = []
                        this.$notify({title: 'Package successfully deleted!', text: "", type: "success"});
                        this.slackDeployLog(deployedPackage.name);
                    })
                    .catch((error) => {
                        this.deleting = []
                        this.$notify({title: 'Package delete failed!', text: error, type: "success"});
                    })
            }).catch(() => {})
        },
        slackDeployLog(name){
            let deployData = {
                'icon_emoji': ':hammer:',
                'text': "<@"+PermissionsStoreUtils.getMyName()+"> delete package",
                'attachments': [{
                    'color': '#fc0318',
                    'fields': [
                        {"title": "Environment", 'value': SlackLogManager.getEnv(), 'short': true},
                        {"title": "Name", 'value': name, 'short': true},
                    ]
                }]
            }
            SlackLogManager.log(deployData)
        },
    },
    computed:{
        deployedPackages(){
            return PackageStoreUtils.getDeployedPackages()
        }
    }
}
</script>

<style scoped>
</style>